import HtmlFrame from "./T2";
import { Routes, Route, Link } from "react-router-dom";
function Weedings() {
    return (
        <Routes>
            <Route path="/" element={<HtmlFrame />}>
            </Route>
        </Routes>
    )
}
export default Weedings;